// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"fdf9c574","488":"1a5615b8","684":"13e0c3b8"}[chunkId] + ".chunk.js";
};